import { Container, Row, Col } from "reactstrap";

import {
    TrendingUp,
    AutoAwesome,
    Speed,
    Public,
    Code,
    Engineering,
    WorkspacePremium,
    AccountTree,
    SwapHoriz,
    Verified
} from "@mui/icons-material";

import "./CAD_Why_Learn.css";


const defaultItems = [
    {
        title: "High Demand, High Salary",
        description:
            "CAD automation engineers are highly valued in product companies and R&D teams.",
        icon: TrendingUp
    },
    {
        title: "Future-Proof Your Career",
        description:
            "Manual CAD skills are becoming outdated; automation is the future of design engineering.",
        icon: AutoAwesome
    },
    {
        title: "Work Smarter, Not Harder",
        description:
            "Automate repetitive design tasks and save hundreds of work hours.",
        icon: Speed
    },
    {
        title: "Online Flexibility",
        description:
            "Learn anytime, anywhere — perfect for working professionals and students.",
        icon: Public
    },
    {
        title: "No Coding Background Needed",
        description:
            "Courses start from the basics of programming (C#, C++, or Python).",
        icon: Code
    },
    {
        title: "Real Industry Projects",
        description:
            "Build practical tools using SolidWorks API, NX Open, Inventor API, or AutoCAD .NET.",
        icon: Engineering
    },
    {
        title: "Expert-Led Training",
        description:
            "Learn directly from engineers working in top MNC automation teams.",
        icon: WorkspacePremium
    },
    {
        title: "Portfolio-Ready Skills",
        description:
            "Gain skills that you can showcase in interviews and freelance platforms.",
        icon: AccountTree
    },
    {
        title: "Career Switch Made Easy",
        description:
            "Move from traditional CAD roles to specialized automation jobs.",
        icon: SwapHoriz
    },
    {
        title: "Certifications & Placement Support",
        description:
            "Get certified and receive career guidance, project reviews, and resume help.",
        icon: Verified
    }
];


function CADWhyLearn({
    title = "More Reasons to Learn CAD Customization & Automation",
    subtitle = "",
    items = defaultItems
}) {

    return (

        <section className="cad-why-learn">

            <Container>

                {/* =====================================
                    HEADER
                ===================================== */}

                <Row className="justify-content-center">

                    <Col lg="9">

                        <div className="cad-why-header text-center">

                            <span className="cad-why-badge">

                                <span className="cad-why-badge-dot"></span>

                                WHY LEARN CAD AUTOMATION

                            </span>


                            <h2>
                                {title}
                            </h2>


                            <div className="cad-why-divider">

                                <span></span>
                                <span></span>
                                <span></span>

                            </div>


                            {subtitle && (

                                <p>
                                    {subtitle}
                                </p>

                            )}

                        </div>

                    </Col>

                </Row>


                {/* =====================================
                    BENEFIT GRID
                ===================================== */}

                <Row className="g-4">

                    {items.map((item, index) => {

                        const Icon = item.icon;

                        return (

                            <Col
                                lg="6"
                                md="6"
                                sm="12"
                                key={index}
                            >

                                <article className="cad-why-card">

                                    {/* Number */}

                                    <div className="cad-why-number">
                                        {String(index + 1).padStart(2, "0")}
                                    </div>


                                    {/* Icon */}

                                    <div className="cad-why-icon">
                                        <Icon />
                                    </div>


                                    {/* Content */}

                                    <div className="cad-why-content">

                                        <h3>
                                            {item.title}
                                        </h3>

                                        <p>
                                            {item.description}
                                        </p>

                                    </div>


                                    {/* Arrow */}

                                    <div className="cad-why-arrow">
                                        →
                                    </div>

                                </article>

                            </Col>

                        );
                    })}

                </Row>

            </Container>

        </section>
    );
}


export default CADWhyLearn;